const equipmentsObjectToQuery = selectedEquipments => (selectedEquipments.map((equipment) => (equipment.value)).join(','))

export default equipmentsObjectToQuery;